var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import { addressFields } from '../../order-fields';
import { hasDynamicDeliveryPrice } from '../../utils/restaurant';
import DeliveryService, { hasMaxDistance, geocodeByAddress, } from '../../utils/location';
import AddressAutocomplete from './AddressAutocomplete';
import { debounce } from '../../app/lodash-cut';
import OtoSpinner from '../common/OtoSpinner';
var OrderFormAddress = /** @class */ (function (_super) {
    __extends(OrderFormAddress, _super);
    function OrderFormAddress() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.debouncedCheckDistance = debounce(function () {
            if (_this.props.isTakeout) {
                return;
            }
            _this.props.ensureAddressIsValid();
        }, 1000);
        _this.handleAddressChange = function (address) {
            return _this.props.setValues(__assign(__assign({}, _this.props.values), { address: address }));
        };
        _this.handleAddressSelect = function (newAddress) {
            geocodeByAddress(newAddress)
                .then(function (googleMapPlace) {
                var newDeliveryPrefs = DeliveryService.mapGooglePlaceToDeliveryPrefs(googleMapPlace, newAddress, _this.props.deliveryMode);
                DeliveryService.saveDeliveryPreferences(newDeliveryPrefs, 'order form address');
                var _a = DeliveryService.getDeliveryPreferences(), street = _a.street, house = _a.house, city = _a.city, flat = _a.flat;
                _this.props.setValues(__assign(__assign({}, _this.props.values), { address: newAddress, street: street, house: house, city: city, flat: flat }));
            })
                .catch(function (error) { return console.error('Error', error); });
            _this.debouncedCheckDistance();
        };
        _this.setHouseErrorIfPresent = function (house) {
            if (_this.props.isTakeout) {
                return;
            }
            if (!house) {
                _this.props.setErrors(__assign(__assign({}, _this.props.errors), { house: 'Brak możliwości dostawy - proszę podać numer budynku.' }));
            }
            else {
                _this.props.setErrors(__assign(__assign({}, _this.props.errors), { house: undefined }));
            }
        };
        _this.shouldCheckDistanceOrPrice = function () {
            if (_this.props.isTakeout) {
                return false;
            }
            return (hasMaxDistance(_this.props.restaurantDetails) ||
                hasDynamicDeliveryPrice(_this.props.restaurantDetails));
        };
        _this.renderFieldInput = function (field) {
            var _a = _this.props, errors = _a.errors, touched = _a.touched, values = _a.values, handleChange = _a.handleChange;
            if (field.name === 'address') {
                return (React.createElement(FormGroup, { key: field.name, className: "col ".concat(field.className) },
                    React.createElement(Label, null, field.label),
                    React.createElement(AddressAutocomplete, { inputClassName: errors.address ? 'is-invalid' : '', handleSelect: _this.handleAddressSelect, handleValueChange: _this.handleAddressChange, value: values.address })));
            }
            return (React.createElement(FormGroup, { key: field.name, className: "col ".concat(field.className) },
                React.createElement(Label, null, field.label),
                React.createElement(Input, { type: field.type || 'text', valid: touched[field.name] && !errors[field.name], invalid: touched[field.name] && !!errors[field.name], name: field.name, onChange: handleChange, value: values[field.name] }),
                React.createElement(FormFeedback, null, errors[field.name])));
        };
        _this.hasError = function () {
            var errors = _this.props.errors;
            return Object.values(errors).filter(function (el) { return !!el; }).length;
        };
        return _this;
    }
    OrderFormAddress.prototype.componentDidMount = function () {
        var _a = DeliveryService.getDeliveryPreferences() || {
            address: '',
            city: '',
            house: '',
            street: '',
        }, address = _a.address, city = _a.city, house = _a.house, street = _a.street;
        this.props.setValues(__assign(__assign({}, this.props.values), { address: address, city: city, house: house, street: street }));
        if (street && house && this.shouldCheckDistanceOrPrice()) {
            this.debouncedCheckDistance();
        }
        this.setHouseErrorIfPresent(house);
    };
    OrderFormAddress.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props.values, street = _a.street, house = _a.house;
        var _b = prevProps.values, oldStreet = _b.street, oldHouse = _b.house;
        if (!!street && !!house) {
            if (street !== oldStreet || house !== oldHouse) {
                this.debouncedCheckDistance();
            }
            if (house !== oldHouse) {
                this.setHouseErrorIfPresent(house);
            }
        }
    };
    OrderFormAddress.prototype.render = function () {
        if (this.props.isTakeout) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            addressFields.map(this.renderFieldInput),
            this.renderCheckDistanceAndPrice()));
    };
    OrderFormAddress.prototype.renderCheckDistanceAndPrice = function () {
        var _a = this.props, addressInRangeMessage = _a.addressInRangeMessage, distanceLoading = _a.distanceLoading;
        if (!this.shouldCheckDistanceOrPrice()) {
            return null;
        }
        return (React.createElement("div", { className: "col-12" },
            distanceLoading && React.createElement(OtoSpinner, { className: "ml-2" }),
            !!this.hasError() && this.renderErrors(),
            !this.hasError() && addressInRangeMessage && (React.createElement("div", { className: "text-success" }, addressInRangeMessage))));
    };
    OrderFormAddress.prototype.renderErrors = function () {
        var errors = this.props.errors;
        return (React.createElement(React.Fragment, null, Object.values(errors).map(function (error) {
            return error ? (React.createElement("div", { key: typeof error === 'string' ? error : JSON.stringify(error), className: "text-danger" }, typeof error === 'string' ? error : error.toString())) : ('');
        })));
    };
    OrderFormAddress.propTypes = {
        addressInRangeMessage: PropTypes.string,
        ensureAddressIsValid: PropTypes.func.isRequired,
        distanceLoading: PropTypes.bool,
        errors: PropTypes.object.isRequired,
        handleChange: PropTypes.func.isRequired,
        restaurantDetails: PropTypes.object.isRequired,
        setValues: PropTypes.func.isRequired,
        values: PropTypes.object.isRequired,
        touched: PropTypes.object.isRequired,
        isTakeout: PropTypes.bool.isRequired,
    };
    OrderFormAddress.displayName = 'OrderFormAddress';
    return OrderFormAddress;
}(React.Component));
export default OrderFormAddress;
